(function ($) {

    $(document).ready(function () {

        if (location.pathname == '/about/outcomes/') {
            window.location.href = '/about#outcomes/';
        } else if (location.pathname == '/about/process/') {
            window.location.href = '/about#process/';
        } else if (location.pathname == '/about/what/') {
            window.location.href = '/about/';
        }

        window.onerror = function (msg, url, line, col, error) {
            if (error === "slick-prevent-error") {
                return true;  //  silent the error, and keep functioning as normal
            }
        };


        if ($('body').hasClass('page-template-page_about')) {

            var submenu = $('header .mainline .navbar-collapse ul.navbar-nav>li.about .sub-menu'),
                slider = $('.page-template-page_about #content'),
                currentSlide;
            submenu.attr('currentSlide', 0);
            if (!window.location.hash) {
                window.location.hash = 'what';
            }
            slider.on('afterChange', function (event, slick) {
                currentSlide = slick.currentSlide;
                submenu.attr('currentSlide', currentSlide);
            });

            slider.on('init afterChange', function (event, slick) {
                setTimeout(function () {
                    $(window).trigger('resize');
                }, 1000);
                if (first_load == true) {
                    first_load = false;
                    setTimeout(function () {
                        slider.slick('setHeight');
                        var dest = $('.process_steps').offset().top - 140;
                        $('html, body').animate({scrollTop: dest}, '1000');
                    }, 1000);
                }

            });

            slider.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                dots: false,
                arrows: false,
                draggable: false,
                accessibility: false
            });

            let isMain = true;

            slider.on('beforeChange', function (event, s, current, next) {
                slider.slick('setHeight');
            });


            $('a[href^="/about#"]').on('click', function (e) {
                isMain = true;
                e.preventDefault();
                var index = $(this).attr('href').split('/about#')[1];
                $('html, body').animate({scrollTop: 0}, 500);
                setTimeout(function () {
                    slider.slick('slickGoTo', index);
                    slider.slick('setHeight');
                    if (index === '1') {
                        window.location.hash = 'process';
                        var ajaxurl = ajaxMeta.ajaxurl,
                            process_step = 1;
                        $.ajax({
                            url: ajaxurl,
                            type: 'post',
                            data: {
                                action: 'process_steps',
                                'process_step': 'step_1'
                            },
                            success: function (data) {

                                var $data = $(data),
                                    container = $(".page-template-page_process .process_steps");

                                if ($data.length) {
                                    container.empty().append($data).find(".process-step").fadeIn("slow");

                                    $('.parallax-background').parallaxBackground();
                                    $('.parallax-content').parallaxContent({
                                        shift: -60,
                                        duration: 2
                                    });

                                    slider.slick('slickGoTo', currentSlide);


                                    if ($(".page-template-page_process .step_1 .finding-slider").length) {

                                        let fSlider = $('.finding-slider__container');

                                        fSlider.slick({
                                            autoplay: false,
                                            accessibility: false,
                                            slidesToShow: 4,
                                            slidesToScroll: 1,
                                            infinite: true,
                                            draggable: true,
                                            arrows: true,
                                            prevArrow: $('.finding__slider--prev'),
                                            nextArrow: $('.finding__slider--next'),

                                            responsive: [{

                                                breakpoint: 992,
                                                settings: {
                                                    slidesToShow: 3,
                                                }

                                            }, {

                                                breakpoint: 768,
                                                settings: {
                                                    slidesToShow: 2,
                                                }

                                            }, {

                                                breakpoint: 576,
                                                settings: {
                                                    slidesToShow: 1,
                                                }

                                            }]
                                        });

                                        fSlider.on('afterChange', function (event, current, next) {
                                            event.stopPropagation();

                                        });
                                        fSlider.on('beforeChange', function (event, s, current, next) {
                                            event.stopPropagation();
                                        });

                                    }


                                    $(".future-scanning__link").on("click", function (e) {
                                        e.preventDefault();

                                        let target = e.target.getAttribute('href'),
                                            targetOffset = $(target).offset();

                                        if (targetOffset) {
                                            $("html, body").animate({
                                                scrollTop: targetOffset.top - 130
                                            }, 1000);
                                        } else {
                                            return;
                                        }
                                    });


                                } else {
                                    container.empty().append('<p class="nothing-found" style="display: none;">Nothing found</p>').find(".nothing-found").fadeIn("slow");
                                }
                            }
                        });


                    } else {
                        if (index === '0') {
                            window.location.hash = 'what';
                        }
                        if (index === '2') {
                            window.location.hash = 'outcomes';
                        }

                    }
                }, 500);
                if ($(this).closest('.sub-menu').length) {
                    $('.menu-trigger').click();
                }

            });


            $(".page-template-page_process .process_steps .process-step").show();

            $(".process_steps").on("click", ".mypoint", function (e) {
                e.preventDefault();
                var ajaxurl = ajaxMeta.ajaxurl,
                    process_step = $(this).data("step");


                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'process_steps',
                        'process_step': process_step
                    },
                    success: function (data) {

                        var $data = $(data),
                            container = $(".page-template-page_process .process_steps");

                        if ($data.length) {
                            container.empty().append($data).find(".process-step").fadeIn("slow");

                            $('.parallax-background').parallaxBackground();
                            $('.parallax-content').parallaxContent({
                                shift: -60,
                                duration: 2
                            });

                            slider.slick('slickGoTo', currentSlide);


                            if ($(".page-template-page_process .step_1 .finding-slider").length) {

                                let fSlider = $('.finding-slider__container');

                                fSlider.slick({
                                    autoplay: false,
                                    accessibility: false,
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    draggable: true,
                                    arrows: true,
                                    prevArrow: $('.finding__slider--prev'),
                                    nextArrow: $('.finding__slider--next'),

                                    responsive: [{

                                        breakpoint: 992,
                                        settings: {
                                            slidesToShow: 3,
                                        }

                                    }, {

                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 2,
                                        }

                                    }, {

                                        breakpoint: 576,
                                        settings: {
                                            slidesToShow: 1,
                                        }

                                    }]
                                });

                                fSlider.on('afterChange', function (event, current, next) {
                                    event.stopPropagation();

                                });
                                fSlider.on('beforeChange', function (event, s, current, next) {
                                    event.stopPropagation();
                                });

                            }


                            $(".future-scanning__link").on("click", function (e) {
                                e.preventDefault();

                                let target = e.target.getAttribute('href'),
                                    targetOffset = $(target).offset();

                                if (targetOffset) {
                                    $("html, body").animate({
                                        scrollTop: targetOffset.top - 130
                                    }, 1000);
                                } else {
                                    return;
                                }
                            });

                            window.location.hash = process_step;

                            setTimeout(function () {
                                slider.slick('setHeight');
                                var dest = $('.process_steps').offset().top - 140;
                                $('html, body').animate({scrollTop: dest}, '1000');
                            }, 1000);

                        } else {
                            container.empty().append('<p class="nothing-found" style="display: none;">Nothing found</p>').find(".nothing-found").fadeIn("slow");
                        }
                    }
                });

                return false;

            });

            $(".page-template-page_process .graphic-wrap .point").on("click", function () {

                var ajaxurl = ajaxMeta.ajaxurl,
                    process_step = $(this).data("step");


                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'process_steps',
                        'process_step': process_step
                    },
                    success: function (data) {

                        var $data = $(data),
                            container = $(".page-template-page_process .process_steps");

                        if ($data.length) {
                            container.empty().append($data).find(".process-step").fadeIn("slow");

                            $('.parallax-background').parallaxBackground();
                            $('.parallax-content').parallaxContent({
                                shift: -60,
                                duration: 2
                            });

                            slider.slick('slickGoTo', 1);

                            if ($(".page-template-page_process .step_1 .finding-slider").length) {


                                let fSlider = $('.finding-slider__container');

                                fSlider.slick({
                                    autoplay: false,
                                    accessibility: false,
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    draggable: true,
                                    arrows: true,
                                    prevArrow: $('.finding__slider--prev'),
                                    nextArrow: $('.finding__slider--next'),

                                    responsive: [{

                                        breakpoint: 992,
                                        settings: {
                                            slidesToShow: 3,
                                        }

                                    }, {

                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 2,
                                        }

                                    }, {

                                        breakpoint: 576,
                                        settings: {
                                            slidesToShow: 1,
                                        }

                                    }]
                                });

                                fSlider.on('afterChange', function (event, current, next) {
                                    event.stopPropagation();

                                });
                                fSlider.on('beforeChange', function (event, s, current, next) {
                                    event.stopPropagation();
                                });

                            }


                            $(".future-scanning__link").on("click", function (e) {
                                e.preventDefault();

                                let target = e.target.getAttribute('href'),
                                    targetOffset = $(target).offset();

                                if (targetOffset) {
                                    $("html, body").animate({
                                        scrollTop: targetOffset.top - 130
                                    }, 1000);
                                } else {
                                    return;
                                }
                            });

                            switch (process_step) {
                                case 'step_1':
                                    window.location.hash = 'futures-scanning';
                                    break;
                                case 'step_2':
                                    window.location.hash = 'resident-engagement';
                                    break;
                                case 'step_4':
                                    window.location.hash = 'scenarios';
                                    break;
                                case 'step_5':
                                    window.location.hash = 'national-vision';
                                    break;
                                case 'step_6':
                                    window.location.hash = 'localized-visions';
                                    break;
                            }


                            setTimeout(function () {
                                slider.slick('setHeight');
                                var dest = $('.process_steps').offset().top - 140;
                                $('html, body').animate({scrollTop: dest}, '1000');
                            }, 1000);

                        } else {
                            container.empty().append('<p class="nothing-found" style="display: none;">Nothing found</p>').find(".nothing-found").fadeIn("slow");
                        }
                    }
                });

                return false;

            });

            if (window.location.hash) {

                let urlParams = new URLSearchParams(window.location.search);

                if (window.location.hash.length != 0 && $('#future-scanning-findings').length != 0 && urlParams.has('section') && urlParams.get('section') === 'future-scanning-findings') {

                    slider.slick('slickGoTo', 1);
                    currentSlide = 1;
                    let headerHeight = $("header.fixed").outerHeight();
                    $('html, body').animate({
                        scrollTop: $($('#future-scanning-findings')).offset().top - (headerHeight + 110) + 'px'
                    }, 2500);

                    window.history.replaceState("/about/?section=future-scanning-findings#step_1", "Refreshed", "/about/#process");
                    $(".navbar-nav").find("li:first-child").addClass("current_page_parent");

                } else {
                    if (window.location.hash.match("^#step_")) {
                        isMain = true;
                        var first_load = true,
                            hash = window.location.hash.substring(1);
                        $(".page-template-page_process .graphic-wrap .point[data-step='" + hash + "']").click();
                        slider.slick('slickGoTo', 1);
                        slider.slick('setHeight');
                    }
                    switch (window.location.hash) {
                        case '#futures-scanning':
                            isMain = true;
                            slider.slick('slickGoTo', 1);
                            slider.slick('setHeight');
                            $(".page-template-page_process .graphic-wrap .point[data-step=step_1]").click();
                            break;
                        case '#resident-engagement':
                            isMain = true;
                            slider.slick('slickGoTo', 1);
                            slider.slick('setHeight');
                            $(".page-template-page_process .graphic-wrap .point[data-step=step_2]").click();
                            break;
                        case '#scenarios':
                            isMain = true;
                            slider.slick('slickGoTo', 1);
                            slider.slick('setHeight');
                            $(".page-template-page_process .graphic-wrap .point[data-step=step_4]").click();
                            break;
                        case '#national-vision':
                            isMain = true;
                            slider.slick('slickGoTo', 1);
                            slider.slick('setHeight');
                            $(".page-template-page_process .graphic-wrap .point[data-step=step_5]").click();
                            break;
                        case '#localized-visions':
                            isMain = true;
                            slider.slick('slickGoTo', 1);
                            slider.slick('setHeight');
                            $(".page-template-page_process .graphic-wrap .point[data-step=step_6]").click();
                            break;
                        case '#learning-mosaic':
                            isMain = true;
                            slider.slick('slickGoTo', 1);
                            slider.slick('setHeight');
                            $(".page-template-page_process .graphic-wrap .point[data-step=step_1]").click();
                            $('.popup.popup-06').fadeIn('slow');
                            break;


                    }

                    if (window.location.hash == '#what') {
                        isMain = true;
                        slider.slick('slickGoTo', 0);
                        slider.slick('setHeight');
                    }

                    if (window.location.hash == '#outcomes') {
                        isMain = true;
                        slider.slick('slickGoTo', 2);
                        slider.slick('setHeight');
                    }
                    if (window.location.hash == '#process') {
                        isMain = true;
                        slider.slick('slickGoTo', 1);
                        slider.slick('setHeight');
                        var ajaxurl = ajaxMeta.ajaxurl,
                            process_step = 1;
                        $.ajax({
                            url: ajaxurl,
                            type: 'post',
                            data: {
                                action: 'process_steps',
                                'process_step': 'step_1'
                            },
                            success: function (data) {

                                var $data = $(data),
                                    container = $(".page-template-page_process .process_steps");

                                if ($data.length) {
                                    container.empty().append($data).find(".process-step").fadeIn("slow");

                                    $('.parallax-background').parallaxBackground();
                                    $('.parallax-content').parallaxContent({
                                        shift: -60,
                                        duration: 2
                                    });

                                    slider.slick('slickGoTo', currentSlide);


                                    if ($(".page-template-page_process .step_1 .finding-slider").length) {

                                        let fSlider = $('.finding-slider__container');

                                        fSlider.slick({
                                            autoplay: false,
                                            accessibility: false,
                                            slidesToShow: 4,
                                            slidesToScroll: 1,
                                            infinite: true,
                                            draggable: true,
                                            arrows: true,
                                            prevArrow: $('.finding__slider--prev'),
                                            nextArrow: $('.finding__slider--next'),

                                            responsive: [{

                                                breakpoint: 992,
                                                settings: {
                                                    slidesToShow: 3,
                                                }

                                            }, {

                                                breakpoint: 768,
                                                settings: {
                                                    slidesToShow: 2,
                                                }

                                            }, {

                                                breakpoint: 576,
                                                settings: {
                                                    slidesToShow: 1,
                                                }

                                            }]
                                        });

                                        fSlider.on('afterChange', function (event, current, next) {
                                            event.stopPropagation();

                                        });
                                        fSlider.on('beforeChange', function (event, s, current, next) {
                                            event.stopPropagation();
                                        });

                                    }


                                    $(".future-scanning__link").on("click", function (e) {
                                        e.preventDefault();

                                        let target = e.target.getAttribute('href'),
                                            targetOffset = $(target).offset();

                                        if (targetOffset) {
                                            $("html, body").animate({
                                                scrollTop: targetOffset.top - 130
                                            }, 1000);
                                        } else {
                                            return;
                                        }
                                    });


                                } else {
                                    container.empty().append('<p class="nothing-found" style="display: none;">Nothing found</p>').find(".nothing-found").fadeIn("slow");
                                }
                            }
                        });

                    }
                }


            }

            function removeHash() {
                history.pushState("", document.title, window.location.pathname
                    + window.location.search);
            }

            $(document).on("click", ".scenario-video-section .video-main .video-cover-wrap .video", function () {
                $('.scenario-video-section .video-cover-wrap .video').removeClass('select');
                if ($('.scenario-video-section .video-cover-wrap .video').hasClass('thumbnails')) {

                } else {
                    $('.scenario-video-section .video-cover-wrap .video').addClass('thumbnails');
                    $('.scenario-video-section .video-main .general-video').addClass('open');
                }
                $(this).addClass('select');
                var video = $(this).data('video');
                var image = $(this).data('image');
                $('.scenario-video-section .video-main .general-video .video').css('background-image','url('+image+')');
                $('.scenario-video-section .video-main .general-video .video').html(video);
            });

            $(document).on("click", ".scenario-video-section .video-main .close", function () {
                $('.scenario-video-section .video-main .general-video .video').html('');

                $('.scenario-video-section .video-cover-wrap .video').removeClass('select');
                $('.scenario-video-section .video-cover-wrap .video').removeClass('thumbnails');
                $('.scenario-video-section .video-main .general-video').removeClass('open');
            })
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/process_parts.es6